
import USER_ROLES from '../global/variables/userRoles';
import USER_STATUS from '../global/variables/userStatus';

export const validateUserLoginInformation = ({
  name,
  email,
  roles,
  firstAccess,
  userGroup,
  status
}) => {
  if(!name || typeof name !== "string"){
    throw new Error("O campo nome do usuário está inválido");
  }

  if(!email || typeof email !== "string"){
    throw new Error("O campo email do usuário está inválido");
  }

  if(!firstAccess || typeof firstAccess !== "string"){
    throw new Error("O campo primeiro acesso está inválido");
  }

  if(!status || typeof status !== "string" || !Object.keys(USER_STATUS).includes(status)){
    throw new Error("O campo status está inválido");
  }

  if(firstAccess === "true"){
    return
  }

  if(!roles || typeof roles !== "string" || !Object.keys(USER_ROLES).includes(roles)){
    throw new Error("O campo de acesso do usuário está inválido");
  }

  if(!Array.isArray(userGroup) || typeof userGroup[0] !== "string"){
    throw new Error("O campo de grupo do usuário está inválido");
  }
}

export const validateUserInformation = ({
  name,
  email,
  roles,
  firstAccess,
  userGroup,
  status
}) => {
  if(!name || typeof name !== "string"){
    throw new Error("O campo Nome do usuário está inválido");
  }

  if(!email || typeof email !== "string"){
    throw new Error("O campo Email do usuário está inválido");
  }

  if(typeof firstAccess !== "boolean"){
    throw new Error("O campo primeiro acesso está inválido");
  }

  if(!status || typeof status !== "string" || !Object.keys(USER_STATUS).includes(status)){
    throw new Error("O campo status está inválido");
  }

  if(!roles || typeof roles !== "string" || !Object.keys(USER_ROLES).includes(roles)){
    throw new Error("O campo Nível do usuário está inválido");
  }

  if(!Array.isArray(userGroup) || typeof userGroup[0] !== "string"){
    throw new Error("O campo Grupo está inválido");
  }
}

